import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import ApiAmusementService from "../../../core/api/api.amusementService";
import TextEditor from "../_Components/CkEditor/Index";
import SelectComponent from "../_Components/ReactSelectComponent";
import { tools } from "../../../core/utils/tools"
import { NumericFormat } from "react-number-format";

const CreateOrEditAmusementPackageReserveItem = ({
  showModalReserveItem,
  setShowModalReserveItem,
  selectedReserveItem,
  suppliers,
}) => {
  const [services, setServices] = useState([]);
  const [isStyleActive, setIsStyleActive] = useState(false);
  const timerRef = useRef(null);
  // const [showMsg, setShowMsg] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, submitCount },
    reset,
    setValue,
    getValues,
    watch
  } = useForm({
    defaultValues: {
      id: 0,
      isActive: true,
      amusementServiceId: null,
      defaultReserveCountPerDay: 10,
      amusementServiceReserveItemPackageItems: []
    },
  });

  const { fields, remove, append, update } = useFieldArray({
    control,
    name: "amusementServiceReserveItemPackageItems",
    keyName: "fieldId"
  });

  const sumOfItems = useMemo(() =>
    fields.reduce((sum, item) => ({
      sumOfOp: sum.sumOfOp + (item?.serverReserveItem?.originalPrice ?? 0),
      sumOfSp: sum.sumOfSp + (item?.serverReserveItem?.price ?? 0)
    }), { sumOfOp: 0, sumOfSp: 0 })
    , [fields])

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const services = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(services) && !_.isEmpty(suppliers)) {
          setServices(services);
        }
      } catch (error) {
      }
    };

    fetchServices();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  // حالت ویرایش
  useEffect(() => {
    const fetchReserveItem = async () => {
      if (selectedReserveItem.id !== 0 && services.length > 0) {
        try {
          const response = await ApiAmusementServiceReserveItem.get(selectedReserveItem.id);
          setValue("id", response.data.id);
          setValue("title", response.data.title);
          setValue("isActive", response.data.isActive);
          setValue("tooltip", response.data.tooltip);
          setValue("minimumReserveCountPerDay", response.data.minimumReserveCountPerDay);
          setValue("defaultReserveCountPerDay", response.data.defaultReserveCountPerDay);
          setValue("amusementServiceId", services?.map((item) => ({
            value: item.id,
            label: item.name,
          })).find(item => item.value == response.data.amusementServiceId));


          if (response.data.amusementServiceReserveItemPackageItems?.length) {
            response.data.amusementServiceReserveItemPackageItems.forEach(async (item, index) => {
              const serrrvice = services?.map((itemm) => ({
                value: itemm.id,
                label: itemm.name,
              })).find(itemm => itemm.value == item.amusementServiceId)
              setValue(`amusementServiceReserveItemPackageItems.${index}.amusementService`, serrrvice)
              await onAmusementServiceChanges(serrrvice, index)
              const subItem = watch("amusementServiceReserveItemPackageItems")[index]
              const ittttem = subItem.reserveItems.find(itemm => itemm.id == item.amusementServiceReserveItemId)
              onReserveItemChanges(subItem.reserveItems, subItem, index)
              setValue(`amusementServiceReserveItemPackageItems.${index}.reserveItem`, { value: ittttem.id, label: ittttem.title })
              setValue(`amusementServiceReserveItemPackageItems.${index}.serverReserveItem`, ittttem)
              setValue(`amusementServiceReserveItemPackageItems.${index}.id`, item.id)
              // setValue(`amusementServiceReserveItemPackageItems.${index}.usePackageCapacity`, item.usePackageCapacity)
              // setValue(`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`, item.usePackageReserveCount)
              // setValue(`amusementServiceReserveItemPackageItems.${index}.minimumReserveCountPerDay`, item.minimumReserveCountPerDay)
              // setValue(`amusementServiceReserveItemPackageItems.${index}.defaultReserveCountPerDay`, item.defaultReserveCountPerDay)
            })
          }

        } catch (error) {
        }
      } else {
        reset({
          id: 0,
          amusementServiceId: null,
        });
      }
    };

    fetchReserveItem();
  }, [selectedReserveItem, services, setValue]);

  const handleClose = () => {
    setShowModalReserveItem(false);
    if (submitCount)
      document.getElementById("submitButton").click();
  };

  const onAmusementServiceChanges = useCallback(async (amusementService, index, isAdd) => {
    const reserveItems = amusementService?.value ? await ApiAmusementServiceReserveItem.getAllReserveItems(amusementService?.value) : []
    if (isAdd) {
      append({
        id: 0,
        amusementService,
        reserveItems
        // usePackageReserveCount: false,
        //  usePackageCapacity: false 
      })
      setIsStyleActive(true);

      // اگر تایمر قبلی وجود داشت، پاکش کن (برای جلوگیری از تداخل)
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      const scrollableContainer = document.querySelector(".scrollDialog")
      requestAnimationFrame(() => {
        scrollableContainer.scrollBy({ top: window.innerWidth < 768 ? 468 : 225, behavior: "smooth" })
        timerRef.current = setTimeout(() => {
          setIsStyleActive(false); // بعد از ۵ ثانیه استایل را غیرفعال کن
          timerRef.current = null; // رفرنس را ریست کن
        }, 5000); // ۵۰۰۰ میلی‌ثانیه = ۵ ثانیه
      })
    }
    else
      update(index, { amusementService, reserveItems })
  }, [update, timerRef.current, window.innerWidth])

  const onReserveItemChanges = useCallback((reserveItemm, subItem, index) => {
    const serverReserveItem = subItem.reserveItems?.find(item => item.id == reserveItemm?.value)
    update(index, { ...subItem, serverReserveItem })
  }, [update])

  const onSubmit = async (data) => {
    data.reserveItemType = 1
    data.amusementServiceId = data.amusementServiceId.value
    data.amusementServiceReserveItemPackageItems = data.amusementServiceReserveItemPackageItems.map((item, index) => ({
      id: item.id,
      amusementServiceId: item.amusementService.value,
      amusementServiceReserveItemId: item.reserveItem.value,
      viewOrder: index + 1
      // usePackageCapacity: item.usePackageCapacity,
      // usePackageReserveCount: item.usePackageReserveCount,
      // minimumReserveCountPerDay: item.usePackageReserveCount ? item.minimumReserveCountPerDay : undefined,
      // defaultReserveCountPerDay: item.usePackageCapacity ? item.defaultReserveCountPerDay : undefined,
    }))

    try {
      let response = null;
      if (data.id > 0) {
        response = await ApiAmusementServiceReserveItem.update(data.id, data);
      } else {
        response = await ApiAmusementServiceReserveItem.create(data);
      }
      if (response.succeeded == true) document.getElementById("submitButton").click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      handleClose()
    } catch (error) {
    }

  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal className="scrollDialog" centered show={showModalReserveItem} size="xl" onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                ایجاد پکیج آیتم رزرو
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div className="rounded-2 px-3 py-1 pb-5" style={{ border: "3px solid #81aced" }}>
                  <div
                    className="bg-white px-3 position-absolute d-inline-block text-primary"
                    style={{ marginTop: "-14px", width: "auto" }}
                  >
                    اطلاعات اصلی
                    </div>
                  <Row className="mt-3 align-items-center">
                    <Col xs="12" className="pl-0">
                      <FormControlLabel
                        className="mb-0"
                        control={
                          <Controller
                            control={control}
                            name="isActive"
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { invalid, isTouched, isDirty, error },
                            }) => (
                              <Checkbox
                                color="primary"
                                onBlur={onBlur}
                                onChange={onChange}
                                checked={value || false}
                                inputRef={ref}
                              />
                            )}
                          />
                        }
                        label="فعال / غیرفعال کردن آیتم"
                      />
                    </Col>
                    <Col xs="12" xl="6" style={{ zIndex: "4" }}>
                      <Controller
                        name="amusementServiceId"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange } }) => (
                          <SelectComponent
                            name="service"
                            className="w-100 mt-2"
                            variant="outlined"
                            size="small"
                            placeholder="انتخاب تفریح"
                            options={services?.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            value={getValues("amusementServiceId") || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                      {errors.amusementServiceId && (
                        <div className="mt-2 pl-4 text-danger">**لطفا تفریح را وارد نمایید</div>
                      )}
                    </Col>

                    <Col xs="12" xl="6">
                      <Controller
                        name="title"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="عنوان"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            className="m-0 mt-5 mt-xl-2"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.title && <div className="mt-2 pl-4 text-danger">**لطفا عنوان را وارد نمایید</div>}
                    </Col>

                    <Col xs="12" xl="6" className="mt-3 mb-2 font-size-sm">
                      <div className="mb-2">توضیحات قابل نمایش در tooltip</div>
                      <div>
                        <Controller
                          name="tooltip"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <TextEditor
                              data={value || ""}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                onChange(data);
                              }}
                            />
                          )}
                        />
                      </div>
                    </Col>
                    <Col style={{ minHeight: 64.23 }} xs="12" xl="3" className="mb-2 font-size-sm">
                      <Controller
                        name="minimumReserveCountPerDay"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="حداقل تعداد"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            className="m-0"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                    </Col>
                    <Col style={{ minHeight: 64.23 }} xs="12" xl="3" className="mb-2 font-size-sm">
                      <Controller
                        name="defaultReserveCountPerDay"
                        control={control}
                        rules={{ required: "**لطفاظرفیت روزانه را وارد نمایید" }}
                        render={({ field: { onChange, value }, fieldState }) => (
                          <>
                            <TextField
                              label="ظرفیت روزانه"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              className="m-0"
                              value={value || ""}
                              onInput={onChange}
                            />
                            <div className="mt-2 pl-4 text-danger">{fieldState?.error?.message}</div>
                          </>
                        )}
                      />
                    </Col>
                  </Row>
                </div>
              </Row>
              <Row className="mt-4">
                <div className="rounded-2 px-3 py-1 pb-5" style={{ border: "3px solid #81aced" }}>
                  <div
                    className="bg-white px-3 position-absolute d-inline-block text-primary"
                    style={{ marginTop: "-14px", width: "auto" }}
                  >
                    آیتم های پکیج
                    </div>
                  <Row className="mt-3 m-0 justify-content-center">
                    {fields.map((subItem, index) =>
                      <Row style={{ border: `2px solid ${!!subItem?.serverReserveItem?.reservationByPhone ? "rgb(255,168,0)" : isStyleActive && index == fields.length - 1 ? "rgb(27,197,189)" : "rgba(0,0,0,0.3)"}` }} className="rounded-4 m-0 my-4 position-relative align-items-center p-0" key={subItem.fieldId + "_" + index}>
                        {!!subItem?.serverReserveItem?.reservationByPhone && <div
                          className="bg-white px-3 position-absolute d-inline-block text-warning"
                          style={{ top: -14, left: "50%", transform: "translateX(-50%)", width: "auto" }}
                        >
                          این آیتم رزرو تلفنی <b>دارد</b>
                        </div>}
                        {isStyleActive && index == fields.length - 1 && <div
                          className="bg-white px-3 position-absolute d-inline-block text-success"
                          style={{ top: -14, left: "50%", transform: "translateX(-50%)", width: "auto" }}
                        >
                          <b>جدید</b>
                        </div>}
                        <Col xs="12" className={`d-flex px-0 py-4 ${window.innerWidth < 768 && "flex-column-reverse gap-2"}`}>
                          <Col style={{ maxWidth: window.innerWidth < 768 ? "100%" : "fit-content" }} className="d-flex align-items-center mt-2">
                            <button
                              onClick={() => {
                                remove(index)
                                if (index == fields.length - 1) {
                                  setIsStyleActive(false)
                                  clearTimeout(timerRef.current);
                                  timerRef.current = null
                                }
                              }}
                              type="button"
                              className={`delete-btn h-100 ${window.innerWidth < 768 && "w-100"}`}
                            >
                              <i className="fas fa-trash" />
                            </button>
                          </Col>
                          <Col className="flex-grow-1 d-flex align-items-center justify-content-around flex-wrap p-0">
                            <Col xs="12" style={{ borderBottom: "1px solid rgba(0,0,0,0.1)", borderRadius: 15 }} className="p-0 d-flex flex-wrap align-items-center">
                              <Col style={{ minHeight: 68 }} xs="12" md="6">
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.amusementService`}
                                  control={control}
                                  rules={{ required: "**لطفا تفریح را وارد نمایید" }}
                                  render={({ field: { ref, onChange, value, ...otherField }, fieldState }) => (
                                    <>
                                      <SelectComponent
                                        name={`amusementServiceReserveItemPackageItems.${index}.amusementService`}
                                        className="w-100 mt-2"
                                        variant="outlined"
                                        size="small"
                                        placeholder="انتخاب تفریح"
                                        options={services?.map((item) => ({
                                          value: item.id,
                                          label: item.name,
                                        }))}
                                        {...otherField}
                                        value={value ?? ""}
                                        onChange={async (e) => {
                                          await onAmusementServiceChanges(e, index)
                                          onChange(e)
                                        }}
                                        isDisabled
                                      />
                                      <div style={{ fontSize: 10 }} className="mt-2 pl-4 text-danger">{fieldState?.error?.message}</div>
                                    </>
                                  )}
                                />

                              </Col>
                              <Col style={{ minHeight: 68 }} xs="12" md="6">
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.reserveItem`}
                                  control={control}
                                  rules={{ required: "**لطفا آیتم را وارد نمایید" }}
                                  render={({ field: { ref, onChange, value, ...otherField }, fieldState }) => (
                                    <>
                                      <SelectComponent
                                        name={`amusementServiceReserveItemPackageItems.${index}.reserveItem`}
                                        className="w-100 mt-2"
                                        variant="outlined"
                                        size="small"
                                        placeholder="انتخاب آیتم"
                                        options={subItem.reserveItems?.filter(item => item.reserveItemType != 1).map((item) => ({
                                          value: item.id,
                                          label: item.title,
                                        })) ?? []}
                                        {...otherField}
                                        value={(value ?? "")}
                                        onChange={(e) => {
                                          onReserveItemChanges(e, subItem, index)
                                          onChange(e)
                                        }}
                                      />
                                      <div style={{ fontSize: 10 }} className="mt-2 pl-4 text-danger">{fieldState?.error?.message}</div>
                                    </>
                                  )}
                                />
                              </Col>
                              {/* <Col xs="12" md="3" style={{ minWidth: window.innerWidth < 768 && "100%" }}>
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`}
                                  control={control}
                                  render={({ field }) => (
                                    <div style={{ left: 15, top: "37%", transform: "translateY(-50%)", zIndex: 11 }} className="position-absolute p-2 bg-white">
                                      <Checkbox
                                        color="primary"
                                        {...field}
                                        checked={field.value}
                                        className="p-0"
                                        title="تنظیم حداقل تعداد و ظرفیت روزانه"
                                      />
                                    </div>
                                  )}
                                />
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.minimumReserveCountPerDay`}
                                  control={control}
                                  rules={{ required: !!watch(`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`) && "**لطفا حداقل تعداد را وارد نمایید" }}
                                  defaultValue={subItem?.minimumReserveCountPerDay}
                                  render={({ field: { onChange, value }, fieldState }) => (
                                    <>
                                      <TextField
                                        label="حداقل تعداد"
                                        margin="normal"
                                        variant="outlined"
                                        size="small"
                                        className="m-0"
                                        value={value || ""}
                                        onInput={onChange}
                                        disabled={!watch(`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`)}
                                      />
                                      <div style={{ fontSize: 10, height: 8 }} className="mt-2 pl-4 text-danger" >{fieldState?.error?.message}</div>
                                    </>
                                  )}
                                />
                              </Col>
                              <Col xs="12" md="3" style={{ minWidth: window.innerWidth < 768 && "100%" }}>
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`}
                                  control={control}
                                  render={({ field }) => (
                                    <div style={{ left: 15, top: "37%", transform: "translateY(-50%)", zIndex: 11 }} className="position-absolute p-2 bg-white">
                                      <Checkbox
                                        color="primary"
                                        {...field}
                                        checked={field.value}
                                        className="p-0"
                                        title="تنظیم حداقل تعداد و ظرفیت روزانه"
                                      />
                                    </div>
                                  )}
                                />
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.defaultReserveCountPerDay`}
                                  control={control}
                                  defaultValue={subItem?.defaultReserveCountPerDay ?? subItem?.serverReserveItem?.defaultReserveCountPerDay}
                                  rules={{ required: !!watch(`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`) && "**لطفا ظرفیت روزانه را وارد نمایید" }}
                                  render={({ field: { onChange, value }, fieldState }) => (
                                    <>
                                      <TextField
                                        label="ظرفیت روزانه"
                                        margin="normal"
                                        variant="outlined"
                                        size="small"
                                        className="m-0"
                                        value={value || ""}
                                        onInput={onChange}
                                        disabled={!watch(`amusementServiceReserveItemPackageItems.${index}.usePackageReserveCount`)}
                                      />
                                      <div style={{ fontSize: 10, height: 8 }} className="mt-2 pl-4 text-danger" >{fieldState?.error?.message}</div>
                                    </>
                                  )}
                                />
                              </Col>
                              <Col className="d-flex align-items-center gap-2 mb-2">
                                <Controller
                                  name={`amusementServiceReserveItemPackageItems.${index}.usePackageCapacity`}
                                  control={control}
                                  render={({ field }) => (
                                    <Checkbox
                                      color="primary"
                                      {...field}
                                      checked={field.value}
                                      id={`amusementServiceReserveItemPackageItems.${index}.usePackageCapacity`}
                                      className="p-0"
                                      title="استفاده از ظرفیت پکیج"
                                    />
                                  )}
                                />
                                <label className="m-0 p-0" htmlFor={`amusementServiceReserveItemPackageItems.${index}.usePackageCapacity`}>
                                  استفاده از ظرفیت پکیج
                                </label>
                              </Col> */}
                            </Col>
                            <Col xs="12" className="p-0 d-flex flex-wrap align-items-center">
                              <Col xs="5" md="3" style={{ minWidth: window.innerWidth < 768 && "50%" }} className="d-flex flex-column justify-content-center align-items-center mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  تامین کننده
                                </div>
                                <div style={{ fontSize: 12 }} className="text-center d-flex">
                                  {subItem?.serverReserveItem?.supplierCompanyName ?? "-"}
                                </div>
                              </Col>
                              <Col xs="5" md="3" style={{ minWidth: window.innerWidth < 768 && "50%" }} className="d-flex flex-column justify-content-center align-items-center mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  قیمت تسویه با تامین کننده
                                </div>
                                <div style={{ fontSize: 12 }} className="text-center d-flex">
                                  {tools.formatPriceNumber(subItem?.serverReserveItem?.supplierSettlementPrice ?? 0)} تومان
                                </div>
                              </Col>
                              <Col md="3" style={{ minWidth: window.innerWidth < 768 ? "100%" : 195 }} className={`d-flex flex-column justify-content-center align-items-center mt-5 ${window.innerWidth < 768 && "my-5"}`}>
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  نحوه تسویه با تامین کننده
                                </div>
                                <div style={{ fontSize: 12 }} className="text-center d-flex">
                                  {!!subItem?.serverReserveItem?.supplierSettlementType ? subItem?.serverReserveItem?.supplierSettlementType?.replaceAll("_", " ") : "-"}
                                </div>
                              </Col>
                              <Col md="3" className="d-flex flex-column justify-content-center align-items-center mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  نوع صدور بلیط
                                </div>
                                <div style={{ fontSize: 12 }} className="text-center d-flex">
                                  {subItem?.serverReserveItem?.issueTicketType != 0 ? subItem?.serverReserveItem?.issueTicketType?.replaceAll("_", " ") : "-"}
                                </div>
                              </Col>
                            </Col>
                            <Col xs="12" className={`p-0 d-flex flex-wrap align-items-center justify-content-center ${window.innerWidth < 768 && "gap-2"}`}>
                              <Col xs="5" md="3" className="d-flex flex-column align-items-center flex-grow-1 mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  ساعت اتمام فروش
                                </div>
                                <div style={{ fontSize: 12 }} className="">
                                  {subItem?.serverReserveItem?.reservationExpirationTime?.slice(0, 5) ?? "-"}
                                </div>
                              </Col>
                              <Col xs="5" md="3" className="d-flex flex-column align-items-center flex-grow-1 mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  ساعت انجام تفریح
                                </div>
                                <div style={{ fontSize: 12 }} className="text-center d-flex">
                                  {subItem?.serverReserveItem?.executionTime?.slice(0, 5) ?? "-"}
                                </div>
                              </Col>
                              <Col xs="5" md="3" className="d-flex flex-column justify-content-center flex-grow-1 align-items-center mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  قیمت مصوب
                            </div>
                                <div style={{ fontSize: 12 }} className="">
                                  {tools.formatPriceNumber(subItem?.serverReserveItem?.originalPrice ?? 0)} تومان
                            </div>
                              </Col>
                              <Col xs="5" md="3" className="d-flex flex-column justify-content-center flex-grow-1 align-items-center mt-5">
                                <div style={{ fontSize: 10 }} className="fw-bold">
                                  قیمت فروش
                            </div>
                                <div style={{ fontSize: 12 }} className="">
                                  {tools.formatPriceNumber(subItem?.serverReserveItem?.price ?? 0)} تومان
                            </div>
                              </Col>
                            </Col>
                          </Col>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col xs="12" className="p-2 w-100">
                        <Button
                          onClick={(e) => {
                            e.target.closest("button").blur()
                            onAmusementServiceChanges(getValues("amusementServiceId"), fields.length - 2, true)
                          }}
                          type="button"
                          style={{ fontSize: 16, minHeight: 50 }}
                          variant="outline-success"
                          className="d-flex gap-2 align-items-center w-100 justify-content-center"
                        >
                          <i className="fas fa-plus" />
                          <span>
                            افزودن آیتم
                          </span>
                        </Button>
                      </Col>
                    </Row>
                  </Row>
                  <Row className="px-7">
                    <Row style={{ borderTop: "1px solid rgba(0,0,0,0.2)" }} className={`mt-3 m-0 ${window.innerWidth > 768 ? "justify-content-end" : "flex-column"} align-items-center gap-3 p-0 pb-1 pt-5`}>
                      <Col style={{ fontSize: 16, maxWidth: "fit-content" }} className={`fw-bold text-center ${window.innerWidth > 768 ? "ms-auto" : "mb-2"}`}>
                        جمع کل
                    </Col>
                      <Col style={{ maxWidth: window.innerWidth > 768 && 485 }} className="d-flex justify-content-between p-0">
                        <Col style={{ maxWidth: 233 }} className="d-flex flex-column justify-content-center align-items-center gap-1">
                          <div style={{ fontSize: 10 }} className="fw-bold">
                            قیمت مصوب پکیج
                        </div>
                          <div>
                            {tools.formatPriceNumber(sumOfItems.sumOfOp)}
                          </div>
                        </Col>
                        <Col style={{ maxWidth: 233 }} className="d-flex flex-column justify-content-center align-items-center gap-1">
                          <div style={{ fontSize: 10 }} className="fw-bold">
                            قیمت فروش پکیج
                        </div>
                          <div>
                            {tools.formatPriceNumber(sumOfItems.sumOfSp)}
                          </div>
                        </Col>
                      </Col>
                    </Row>
                  </Row>
                </div>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex gap-2">
                <Button variant="success" type="submit" disabled={isSubmitting || !(fields.length > 0)}>
                  ذخیره
                  </Button>
              </div>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div >
  );
};

export default CreateOrEditAmusementPackageReserveItem;
